import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetConversationResponse,
  getConversation as universalGetConversation,
} from './innovation-widget-v1-conversation-conversations.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ai-site-chat' };

export function getConversation(
  httpClient: HttpClient
): GetConversationSignature {
  return () =>
    universalGetConversation(
      // @ts-ignore
      { httpClient }
    );
}

interface GetConversationSignature {
  /**
   * Retrieves the conversation for the site visitor calling this method.
   *
   * This method must be called using the site visitor or site member identity ([SDK](https://dev.wix.com/docs/sdk/articles/get-started/about-identities#site-member) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/about-identities#site-member)) to identify the site visitor that is requesting the conversation.
   */
  (): Promise<
    NonNullablePaths<
      GetConversationResponse,
      `conversation._id` | `conversation.contact`,
      3
    >
  >;
}

export {
  AccountInfo,
  ActionEvent,
  Conversation,
  ConversationParticipantIdOneOf,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetConversationRequest,
  GetConversationResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  MessageEnvelope,
  RestoreInfo,
  WebhookIdentityType,
} from './innovation-widget-v1-conversation-conversations.universal.js';
